import { api } from './api';

export type CreditNoteStatus = 'draft' | 'applied' | 'voided';

export interface CreditNote {
  id: string;
  chambersId: string;
  caseId: string;
  originalFeeNoteId: string;
  creditNoteNumber: string;
  reason: string;
  status: CreditNoteStatus;
  issueDate: string;
  subtotal: string;
  vatAmount: string;
  totalAmount: string;
  currency: string;
  notes: string | null;
  appliedAt: string | null;
  voidedAt: string | null;
  voidReason: string | null;
  createdAt: string;
  updatedAt: string;
  case: { id: string; caseNumber: string; caseName: string } | null;
  originalFeeNote: { id: string; feeNoteNumber: string; total: string } | null;
  createdBy: { id: string; firstName: string; lastName: string } | null;
  voidedBy: { id: string; firstName: string; lastName: string } | null;
}

export interface CreateCreditNotePayload {
  originalFeeNoteId: string;
  totalAmount: number;
  reason: string;
  notes?: string;
}

export interface VoidCreditNotePayload {
  voidReason: string;
}

export async function fetchCreditNotes(params: {
  caseId?: string;
  feeNoteId?: string;
}): Promise<CreditNote[]> {
  const res = await api.get<{ data: CreditNote[] }>('/credit-notes', { params });
  return res.data.data;
}

export async function fetchCreditNote(id: string): Promise<CreditNote> {
  const res = await api.get<{ creditNote: CreditNote }>(`/credit-notes/${id}`);
  return res.data.creditNote;
}

export async function createCreditNote(
  payload: CreateCreditNotePayload,
): Promise<CreditNote> {
  const res = await api.post<{ creditNote: CreditNote }>('/credit-notes', payload);
  return res.data.creditNote;
}

export async function voidCreditNote(
  id: string,
  payload: VoidCreditNotePayload,
): Promise<CreditNote> {
  const res = await api.post<{ creditNote: CreditNote }>(
    `/credit-notes/${id}/void`,
    payload,
  );
  return res.data.creditNote;
}

export const STATUS_LABELS: Record<CreditNoteStatus, string> = {
  draft: 'Draft',
  applied: 'Applied',
  voided: 'Voided',
};
